import React from 'react';
import { SvgIcon } from '@mui/material';
import { iconType } from './icon-types';

const ClearIcon = (properties: iconType) => (
  <>
    <SvgIcon
      {...properties}
      viewBox="0 0 18 18"
      style={{ fill: 'none', width: '18px', height: '18px' }}
    >
      <path d="M5.70711 5.70711L12.7703 12.7703" />
      <path d="M5.83375 12.6519L12.7785 5.70711" />
      <path d="M9.13638 17C13.63 17 17.2728 13.4183 17.2728 9C17.2728 4.58172 13.63 1 9.13638 1C4.64278 1 1 4.58172 1 9C1 13.4183 4.64278 17 9.13638 17Z" />
    </SvgIcon>
  </>
);

ClearIcon.defaultProperties = {
  strokeMiterlimit: '10',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  stroke: '#78869E',
};

export default ClearIcon;
